import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sparkle } from "@phosphor-icons/react";

const ARTICLE_URL = "/blog/id-doudou-etiquette-thermocollante-autocollante";

export const NewsBanner = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4">
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="relative overflow-hidden rounded-[2rem] border border-orange-200 bg-gradient-to-r from-orange-50 via-white to-rose-50 p-6 md:p-8"
      data-testid="news-banner"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex-1">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-500 px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">
            <Sparkle size={12} weight="fill" /> Nouveau
          </span>
          <h2 className="mt-3 font-display text-2xl md:text-3xl font-black text-stone-800">
            Votre doudou a maintenant son ID unique !
          </h2>
          <p className="mt-2 text-stone-600 leading-relaxed max-w-2xl">
            Imprimez-le sur une étiquette thermocollante ou autocollante avec doudou-alert.fr : la personne qui le trouve pourra retrouver sa fiche en un instant.
          </p>
          <Link
            to={ARTICLE_URL}
            className="mt-4 inline-flex items-center gap-2 font-bold text-orange-600 hover:text-orange-700 group"
            data-testid="news-banner-link"
          >
            Lire l'article <ArrowRight size={16} weight="bold" className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
        <Link to={ARTICLE_URL} className="shrink-0 self-center" aria-label="Voir l'exemple d'étiquette" data-testid="news-banner-label">
          <div className="rotate-[-4deg] rounded-xl border-2 border-stone-200 bg-white px-6 py-3 text-center shadow-lg transition-transform hover:rotate-0">
            <p className="font-mono text-xl font-black tracking-[0.2em] text-stone-900">AB3X-K9MZ</p>
            <p className="text-xs font-bold text-orange-600">doudou-alert.fr</p>
          </div>
        </Link>
      </div>
    </motion.div>
  </section>
);

export default NewsBanner;
